import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Edit, Trash2 } from "react-feather";
import NewMenuForm from "./AdminComp/NewMenuForm";


const MenuForm = () => {
  const [menus, setMenus] = useState([]);
  const [title, setTitle] = useState("");
  const [parentId, setParentId] = useState(null);
  const [position, setPosition] = useState(0);
  const [isCategory, setIsCategory] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  // Fetch Menus
  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        const structuredMenus = buildMenuHierarchy(response.data);
        setMenus(structuredMenus);
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  // Recursive function to build menu hierarchy
  const buildMenuHierarchy = (menus, parentId = null, prefix = "") => {
    let result = [];
    menus
      .filter((menu) => menu.parent_id === parentId)
      .forEach((menu) => {
        const fullPath = prefix ? `${prefix} > ${menu.title}` : menu.title;
        result.push({ ...menu, fullTitle: fullPath });

        // Recursively add children
        result = result.concat(buildMenuHierarchy(menus, menu.id, fullPath));
      });
    return result;
  };

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file)); // Generate preview URL
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("parent_id", parentId ? parseInt(parentId) : null);
      formData.append("position", parseInt(position));
      formData.append("is_category", isCategory);
      if (image) formData.append("image", image); // Attach image file
  
      console.log("Sending Form Data:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
  
      const response = await axios.post(`${baseurl}addMenuWithImage`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      console.log("Server Response:", response.data);
  
      // Refresh Menus
      axios.get(`${baseurl}getMenus`).then((response) => setMenus(buildMenuHierarchy(response.data)));
  
      // Reset Form
      setTitle("");
      setParentId(null);
      setPosition(0);
      setIsCategory(false);
      setImage(null);
      setPreview(null);
      setShowModal(false); // Close modal after submission
    } catch (error) {
      console.error("Error adding menu:", error);
    }
  };
  
  

  // Handle Edit
  const handleEdit = (id) => {
    navigate(`/admin/edit-menu/${id}`);
  };

  // Handle Delete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this! All the Dependent Category Will Also deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseurl}deleteMenuById/${id}`)
          .then(() => {
            // Reload menus after deletion
            axios
              .get(`${baseurl}getMenus`)
              .then((response) => setMenus(buildMenuHierarchy(response.data)));
            Swal.fire("Deleted!", "Your menu has been deleted.", "success");
          })
          .catch((error) => {
            console.error("Error deleting menu:", error);
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };

  // Data Table Columns
  const columns = [
    {
      name: "Image",
      cell: (row) => (
        <div className="d-flex">
          <img src={`${imageUrl}menu/${row.image}`} className="img-fluid imhas"/> 
        </div>
      ),
      minWidth: "80px",
      maxWidth: "150px",
    },{
      name: "Title",
      selector: (row) => row.fullTitle,
      sortable: true,
      wrap: true, // Ensures text wraps to the next line
      width: "300px", // Sets a fixed column width
    },
    {
      name: "Parent",
      selector: (row) => (row.parent_id ? `Sub Category ` : "Main Category"),
      minWidth: "80px",
      maxWidth: "150px",
    },
    {
      name: "Position",
      selector: (row) => row.position,
      sortable: true,
      minWidth: "50px",
      maxWidth: "100px",
    },
    {
      name: "Category",
      selector: (row) => (row.is_category ? "Yes" : "No"),
      minWidth: "50px",
      maxWidth: "100px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex">
          <span className="btn btnedit me-2" onClick={() => handleEdit(row.id)}>
            <Edit size={15} />
          </span>
          <span
            className="btn btndelete"
            onClick={() => handleDelete(row.id)} // Delete button
          >
              <Trash2 size={15} />
          </span>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Create Category/Sub-Categories</h4>
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              Add New Menu
            </button>
          </div>

<NewMenuForm/>


          {/* Modal for form */}
          {showModal && (
            <div className="modal fade show" tabIndex="-1" style={{ display: "block" }} aria-modal="true">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add New Menu</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                  <form onSubmit={handleSubmit} className="row g-3 text-start">
      {/* Title */}
      <div className="col-md-12">
        <label className="form-label">Menu Title</label>
        <input
          type="text"
          className="form-control"
          placeholder="Eg. Business & Industrial"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>

      {/* Parent Menu */}
      <div className="col-md-12">
        <label className="form-label">Parent Menu</label>
        <select
          className="form-select"
          value={parentId}
          onChange={(e) => setParentId(e.target.value)}
        >
          <option value="">Main Category</option>
          {menus.map((menu) => (
            <option key={menu.id} value={menu.id}>
              {menu.fullTitle}
            </option>
          ))}
        </select>
      </div>

      {/* Position */}
      <div className="col-md-4">
        <label className="form-label">Position</label>
        <input
          type="number"
          className="form-control"
          placeholder="Enter position"
          value={position}
          onChange={(e) => setPosition(e.target.value)}
        />
      </div>

      {/* Is Category */}
      <div className="col-md-4 d-flex align-items-center">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isCategory}
            onChange={(e) => setIsCategory(e.target.checked)}
          />
          <label className="form-check-label ms-2">Is Category?</label>
        </div>
      </div>

      {/* Image Upload */}
      <div className="col-md-12">
        <label className="form-label">Upload Image</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleImageChange}
        />
      </div>

      {/* Image Preview */}
      {preview && (
        <div className="col-md-12 text-center">
          <div className="image-preview">
            <img src={preview} alt="Preview" className="img-fluid" />
          </div>
        </div>
      )}

      {/* Submit Button */}
      <div className="col-12 text-end">
        <button type="submit" className="btn submitbtnn">
          Add Menu
        </button>
      </div>
    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* DataTable */}
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={menus}
              defaultSortFieldId="title"  // Set default sorting field
  defaultSortAsc={false} 
              pagination
              // selectableRows
              highlightOnHover
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuForm;
